import { AnonymousUser } from 'types'

export enum AnonymousUserActions {
  ANONYMOUS_USER_SET = 'ANONYMOUS_USER_SET',
  RENAME_ANONYMOUS_USER = 'RENAME_ANONYMOUS_USER',
}

export const setAnonymousUser = (user: AnonymousUser) => {
  return { type: AnonymousUserActions.ANONYMOUS_USER_SET, payload: user }
}

export const renameAnonymousUser = (displayName: string) => {
  return {
    type: AnonymousUserActions.RENAME_ANONYMOUS_USER,
    payload: { displayName },
  }
}
